import React from 'react';
import { Search, X } from 'lucide-react';

interface DataTableHeaderProps {
  title?: string;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;
  filters?: React.ReactNode;
  actions?: React.ReactNode;
}

export const DataTableHeader: React.FC<DataTableHeaderProps> = ({
  title,
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Buscar...',
  filters,
  actions,
}) => {
  return (
    <>
      {/* Header con título, búsqueda y acciones */}
      <div className="p-6 border-b border-slate-100 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
        {title && <h3 className="font-bold text-slate-800 text-lg shrink-0">{title}</h3>}

        <div className="flex flex-col sm:flex-row flex-wrap w-full lg:w-auto gap-3 justify-end">
          {/* Search input with debounce */}
          {onSearchChange && (
            <div className="relative flex-1 sm:min-w-64 lg:w-72">
              <input
                type="text"
                value={searchValue ?? ''}
                onChange={(e) => onSearchChange(e.target.value)}
                placeholder={searchPlaceholder}
                className="w-full pl-9 pr-9 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-100"
              />
              <Search className="absolute left-3 top-2.5 text-slate-400" size={16} />
              {searchValue && (
                <button
                  type="button"
                  onClick={() => onSearchChange('')}
                  className="absolute right-2.5 top-2 p-0.5 text-slate-400 hover:text-slate-600 hover:bg-slate-200 rounded transition-colors"
                >
                  <X size={14} />
                </button>
              )}
            </div>
          )}

          {/* Actions (Create button, etc.) */}
          {filters && (
            <div className="flex flex-col sm:flex-row flex-wrap items-stretch gap-3">
              {filters}
            </div>
          )}
          {actions}
        </div>
      </div>

      {/* Filtros en sección separada si existen */}
    </>
  );
};
